
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.046.078a.118.118 0 01.076-.023c.031 0 .057.006.076.017.02.012.033.032.041.059.012.027.02.055.024.082l.017.129a1.705 1.705 0 00.398.95c.196.237.438.38.727.427.078.015.196.023.352.023h2.613c.414 0 .742.1.985.299.265.215.458.516.58.902.125.391.187.764.187 1.12 0 .144-.045.214-.135.21-.039 0-.068-.011-.088-.035a.213.213 0 01-.04-.1 3.954 3.954 0 01-.024-.146l-.03-.187a2.555 2.555 0 00-.04-.2c-.223-.68-.664-1.02-1.325-1.02h-2.7c-.84 0-1.38-.476-1.618-1.429-.238.953-.754 1.43-1.547 1.43H3.91c-.191 0-.336.008-.433.023-.274.055-.51.205-.71.452-.199.25-.318.558-.357.925-.023.192-.074.287-.152.287-.09 0-.135-.066-.135-.199 0-.566.123-1.08.37-1.54.241-.462.595-.721 1.06-.78.078-.008.193-.012.345-.012h2.631c.266 0 .498-.054.698-.164.199-.105.345-.238.439-.398.098-.16.168-.301.211-.422a1.75 1.75 0 00.088-.322A1.389 1.389 0 017.98.225.614.614 0 018 .143a.162.162 0 01.047-.065z","fill":"#000C1F"}}),_c('rect',{attrs:{"x":".622","y":"8.773","width":"15","height":"11","rx":"1.5","stroke":"#000C1F","stroke-dasharray":"4 4"}})])
          )
        }
      }
    